import MyExpApi from "apps/myExperience/enum/MyExpApi";
import ApiProgramOrganizationView from "shared/types/ApiProgramOrganizationView";
import { ApiProgramParticipantView } from "shared/types/ApiProgramParticipantView";
import { useGetApiData } from "shared/datalayer";
import ContextEntityType from "shared/enums/ContextEntityType";
import { EventOrganizationViewType } from "./enum";
import { CustomApiType } from "./types";

export function useGetProfileForDisplay({
  programParticipantId,
  viewerProgramParticipantId,
  viewerEventParticipantId,
  errorHandler,
  contextEntityType,
  customApi
}: {
  programParticipantId?: string;
  viewerProgramParticipantId?: string;
  viewerEventParticipantId?: string;
  errorHandler: () => void;
  contextEntityType?: ContextEntityType;
  customApi?: CustomApiType;
}) {
  return useGetApiData<ApiProgramParticipantView>(
    customApi?.apiUrl ?? MyExpApi.GET_PROFILE_FOR_DISPLAY,
    {
      params: customApi?.params ?? { programParticipantId, viewerProgramParticipantId, viewerEventParticipantId }
    },
    {
      enabled:
        Boolean(customApi?.params) ||
        (contextEntityType === ContextEntityType.PROGRAM_PARTICIPANT &&
          Boolean(programParticipantId) &&
          Boolean(viewerProgramParticipantId || viewerEventParticipantId)),
      onError: () => {
        errorHandler();
      }
    }
  );
}

export function useGetOrganizationProfileForDisplay({
  programOrganizationId,
  viewerProgramParticipantId,
  viewerEventParticipantId,
  errorHandler,
  contextEntityType
}: {
  programOrganizationId?: string;
  viewerProgramParticipantId?: string;
  viewerEventParticipantId: string;
  errorHandler: () => void;
  contextEntityType?: ContextEntityType;
}) {
  return useGetApiData<ApiProgramOrganizationView>(
    MyExpApi.GET_ORGANIZATION_PROFILE_FOR_DISPLAY_BY_PARTICIPANT_ID,
    {
      params: { programOrganizationId, viewerProgramParticipantId, viewerEventParticipantId }
    },
    {
      enabled:
        contextEntityType === ContextEntityType.PROGRAM_ORGANIZATION &&
        Boolean(programOrganizationId) &&
        (Boolean(viewerProgramParticipantId) || Boolean(viewerEventParticipantId)),
      onError: () => {
        errorHandler();
      }
    }
  );
}

export function useGetEventOrganizationProfileForDisplay({
  eventOrganizationId,
  viewerProgramParticipantId,
  viewerEventParticipantId,
  errorHandler,
  contextEntityType,
  viewType
}: {
  eventOrganizationId?: string;
  viewerProgramParticipantId?: string;
  viewerEventParticipantId: string;
  viewType?: EventOrganizationViewType;
  errorHandler: () => void;
  contextEntityType?: ContextEntityType;
}) {
  return useGetApiData<ApiProgramOrganizationView>(
    MyExpApi.GET_EVENT_ORGANIZATION_PROFILE_FOR_DISPLAY_BY_PARTICIPANT_ID,
    {
      params: { eventOrganizationId, viewerProgramParticipantId, viewerEventParticipantId, viewType: viewType }
    },
    {
      enabled:
        contextEntityType === ContextEntityType.EVENT_ORGANIZATION &&
        Boolean(eventOrganizationId) &&
        (Boolean(viewerProgramParticipantId) || Boolean(viewerEventParticipantId)),
      onError: () => {
        errorHandler();
      }
    }
  );
}
